@if (legalRestriction$ | async) {
  <div class="notification notification-warning">
    <mat-icon>warning</mat-icon>
    <div class="text--warning text--bold">
      {{ 'legalRestrictions' | translate }} {{ (cropAid$ | async)?.name }}
    </div>
    @if ((legalRestriction$ | async).maxDosage !== null) {
      <agr-value-row label="{{ 'maxDosage' | translate }}">
        {{ (legalRestriction$ | async).maxDosage }}
      </agr-value-row>
    }
    @if ((legalRestriction$ | async).yearlyDosage !== null) {
      <agr-value-row label="{{ 'yearlyDosage' | translate }}">
        {{ (legalRestriction$ | async).yearlyDosage }}
      </agr-value-row>
    }
    @if ((legalRestriction$ | async).safetyPeriodInDays !== null) {
      <agr-value-row label="{{ 'safetyPeriodInDays' | translate }}">
        {{ (legalRestriction$ | async).safetyPeriodInDays }}
      </agr-value-row>
    }
    @if ((legalRestriction$ | async).intervalInDays !== null) {
      <agr-value-row label="{{ 'intervalInDays' | translate }}">
        {{ (legalRestriction$ | async).intervalInDays }}
      </agr-value-row>
    }
    @if ((legalRestriction$ | async).numberOfTimesPerYear !== null) {
      <agr-value-row label="{{ 'numberOfTimesPerYear' | translate }}">
        {{ (legalRestriction$ | async).numberOfTimesPerYear }}
      </agr-value-row>
    }
  </div>
}
